import Payroll from "./payroll";
export default Payroll;